import React from "react";
import clsx from "clsx";
import type { AlertProps } from "./alert.types";
import { getAlertClasses, getAlertIcon } from "./alert.definitions";

export default function Alert({
  variant = "info",
  title,
  description,
  className,
}: AlertProps) {
  const Icon = getAlertIcon(variant);

  return (
    <div className={clsx(getAlertClasses(variant), className)}>
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <Icon className="h-5 w-5" />
        </div>
        <div className="ml-3">
          {title && (
            <h3 className="text-sm font-medium font-montserrat">{title}</h3>
          )}
          {description && (
            <p className={clsx("text-sm font-montserrat", title ? "mt-1" : "")}>
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
